import { AxiosResponse } from 'axios';
import {
  ICreateOrganizationAdminPayload,
  IUpdateOrganizationAdminPayload,
  IOrganizationAdminListResponse,
  IOrganizationAdmin,
  IOrganizationAdminDeleteResponse,
} from '../../interface/organization-admin.interface';
import api from '../api';

const getOrganizationAdmins = async (params: {
  page: number;
  pageSize: number;
  search?: string;
}): Promise<AxiosResponse<IOrganizationAdminListResponse>> => {
  return api.get('/organization-operator', { params });
};

const createOrganizationAdmin = async (
  payload: ICreateOrganizationAdminPayload,
): Promise<AxiosResponse<IOrganizationAdmin>> => {
  return api.post('/organization-operator', payload);
};

const updateOrganizationAdmin = async (
  id: string,
  payload: IUpdateOrganizationAdminPayload,
): Promise<AxiosResponse<IOrganizationAdmin>> => {
  return api.put(`/organization-operator/${id}`, payload);
};

const deleteOrganizationAdmin = async (
  id: string,
): Promise<AxiosResponse<IOrganizationAdminDeleteResponse>> => {
  return api.delete(`/organization-operator/${id}`);
};

export const organizationAdminService = {
  getOrganizationAdmins,
  createOrganizationAdmin,
  updateOrganizationAdmin,
  deleteOrganizationAdmin,
};
